import { render, staticRenderFns } from "./vehicleBindInfo.vue?vue&type=template&id=f031dd8a&scoped=true&"
import script from "./vehicleBindInfo.vue?vue&type=script&lang=js&"
export * from "./vehicleBindInfo.vue?vue&type=script&lang=js&"
import style0 from "./vehicleBindInfo.vue?vue&type=style&index=0&id=f031dd8a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f031dd8a",
  null
  
)

export default component.exports